import { autoRegisterFeature } from '@store/features/factory';

import { payments } from './store/feature';

// Auto-register the feature
autoRegisterFeature(payments);

// Export components
export type {
  AddPatientPaymentMethodModalProps,
  CopyInvoiceLinkIconButtonProps,
  // Patient Invoices types
  PatientInvoiceCardProps,
  PatientInvoicesBlockProps,
  PatientInvoicesListProps,
  PatientPaymentMethodCardProps,
  PatientPaymentMethodListProps,
  PatientPaymentMethodsBlockProps,
  PaymentsColdStartProps,
  RequestPaymentButtonProps,
} from './components';
export {
  AddPatientPaymentMethodModal,
  CopyInvoiceLinkIconButton,
  // Patient Invoices
  PatientInvoiceCard,
  PatientInvoicesBlock,
  PatientInvoicesList,
  // Patient Payment Methods
  PatientPaymentMethodCard,
  PatientPaymentMethodList,
  PatientPaymentMethodsBlock,
  PaymentsColdStart,
  PaymentsPage,
  RequestPaymentButton,
  StripeConnectButton,
  StripeConnectStatus,
  StripeInvoicesTable,
  StripeInvoicesTableCard,
} from './components';

// Export modal components (for lazy loading in modal registry).
// PaymentRequestModal removed — see features/patient-ledger.
export { default as StripeConnectInfoModal } from './components/StripeConnectInfoModal';

// Export hooks
export { useRequestPayment } from './hooks/useRequestPayment';

// Export store functionality
export {
  payments,
  paymentsApi,
  useChargeLinesPreview,
  useConfirmPatientPaymentMethodMutation,
  // Stripe Connect hooks
  useCreateStripeConnectMutation,
  useCreateStripeDashboardLinkMutation,
  useDeletePatientPaymentMethodMutation,
  // Patient Invoices hooks
  useGetPatientInvoicesQuery,
  useLazyGetInvoiceUrlsQuery,
  // Patient Payment Methods hooks
  useGetPatientPaymentMethodsQuery,
  useGetPatientPaymentMethodStatusQuery,
  useGetStripeConnectStatusQuery,
  useGetStripeInvoicesQuery,
  useLazyGetStripeInvoicesQuery,
  usePatientInvoices,
  usePatientPaymentMethods,
  useReconcileInvoice,
  useReconcileInvoiceMutation,
  useSendInvoiceReminder,
  useSendInvoiceReminderMutation,
  useSendPaymentRequest,
  useSendPaymentRequestMutation,
  useSetDefaultPatientPaymentMethodMutation,
  useSetupPatientPaymentMethodMutation,
  useStripeConnect,
  useStripeDashboard,
} from './store';

// Re-export types from store
export type { InvoiceStatusFilter } from './store';

// Export types (renamed to avoid conflicts)
export type {
  // Patient Payment Methods types
  PatientPaymentMethod,
  PatientPaymentMethodsListResponse,
  PatientPaymentMethodStatus,
  PatientPaymentSetupResponse,
  PaymentRequest,
  PaymentRequestResponse,
  StripeConnectRequest,
  StripeConnectResponse,
  StripeConnectStatus as StripeConnectStatusType,
  StripeDashboardLinkRequest,
  StripeDashboardLinkResponse,
  StripeInvoice,
  StripeInvoicesResponse,
} from './types';
